;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../../utils/cn'
import { Icon as IconComponent } from './icon'

type InputRootProps = React.ComponentProps<'div'>

function InputRoot({ children, className, ...props }: InputRootProps) {
  return (
    <div className={cn('group relative', className)} {...props}>
      {children}
    </div>
  )
}

const inputSlotStyles = cva('absolute top-1/2 -translate-y-1/2', {
  variants: {
    position: {
      left: 'left-3 [&~input]:pl-12',
      // This helps us to ensure that when you position element after the input, the text won't overlap with the icon.
      right: 'right-3 [:has(&)>input]:pr-12',
    },
  },
  defaultVariants: {
    position: 'left',
  },
})

function InputSlot({
  children,
  className,
  position,
}: {
  children: React.ReactNode
  className?: string
  position?: 'left' | 'right'
}) {
  return (
    <Slot
      role="presentation"
      className={inputSlotStyles({
        position,
        className,
      })}
    >
      {children}
    </Slot>
  )
}

const inputVariants = cva([
  'w-full min-w-0 rounded-md border border-gray-300 bg-white text-base font-light text-gray-900 transition-colors file:border-0 [&::-webkit-search-cancel-button]:sr-only',
  'h-10 px-3 py-1',
  'placeholder:text-base placeholder:text-gray-500',
  'file:border-0 file:bg-white file:text-sm file:font-medium',
  'disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400 disabled:placeholder-gray-400 disabled:opacity-50',
  'read-only:border-gray-200 read-only:bg-gray-50 read-only:text-gray-400 read-only:placeholder-gray-400',
  'aria-invalid:border-error-700 aria-invalid:focus:border-error-700',
])

type InputProps = React.ComponentProps<'input'>

function Input({ className, type, ...props }: InputProps) {
  return (
    <input type={type} className={cn(inputVariants(), className)} {...props} />
  )
}

function InputIcon({
  className,
  ...props
}: React.ComponentProps<typeof IconComponent>) {
  return (
    <IconComponent
      {...props}
      className={cn('block size-5 h-5 w-5 shrink-0 text-gray-400', className)}
    />
  )
}

export { Input, InputIcon, InputRoot, InputSlot, inputVariants }
